import { render, staticRenderFns } from "./division.vue?vue&type=template&id=664a8fbc"
import script from "./division.vue?vue&type=script&lang=js"
export * from "./division.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports